import SimpleButton from './simpleButton';

export default class XyloButton extends SimpleButton {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   */
  constructor(scene, x, y, startY, callback, active, callbackOnTing, group) {
    super(scene, x, y, 'xylo', callback);
    this.startOffset = 100;
    this.endOffset = -150;
    this.btnSFX = undefined;
    this.dingY = y + this.startOffset;
    this.startDingY = startY+ this.startOffset;
    this.targetY = y - 100;

    this.callbackOnTing = callbackOnTing;
    this.dinger = scene.add.image(x + 170, this.dingY, 'dinger');
    // console.log(group);
    //console.log(this);
    group.add(this);
    this.depth = 10;
    group.add(this.dinger);
    this.dinger.depth = 11;
    this.dinger.setOrigin(0.5, 1);
    this.active = active;
    this.animating = false;
    this.blocked = false;
    this.holderGroup = group;
  }

  onPress(scene, callback) {
    //console.log('active? ' + this.active + ', blocked? ' + this.blocked);
    if (this.active === true && this.blocked === false) {
      if (this.callbackOnTing == true) {
        if (this.animating == false) {
          super.onPress(scene, callback);
        }
      } else {
        callback();
      }
      //
    }
  }

  animateIn(scene, callback) {
    this.animating = true;

    var tween = scene.tweens.add({
      targets:[this,this.dinger],
      y:'-=100',
      ease: 'Quad.easeInOut',
      duration: 100
    });

    this.dingY = this.startDingY - 100;

    this.pressTween = scene.tweens.add({
      targets: this.dinger,
      props: {
        angle: { value: -90, duration: 150, delay: 100, ease: 'Back.easeIn' },
        y: {
          value: this.dingY + this.endOffset,
          duration: 150,
          ease: 'Quad.easeOut',
          delay: 100
        }
      },

      onComplete: () => {
        scene.sound.play('ting');
        if (callback !== undefined) {
          callback();
        }
        this.pressTween = scene.tweens.add({
          targets: this.dinger,
          props: {
            angle: {
              value: 0,
              duration: 150,
              ease: 'Quad.easeInOut'
            },
            y: {
              value: this.dingY,
              duration: 150,
              ease: 'Quad.easeInOut'
            }
          },
          onComplete: () => {
            this.animating = false;
          }
        });
      }
    });
  }

  animateOut(scene, callback) {
    this.animating = true;

    var tween = scene.tweens.add({
      targets:[this,this.dinger],
      y:'+=100',
      ease: 'Quad.easeInOut',
      duration: 100,
      delay:1000
    });

    this.pressTween = scene.tweens.add({
      targets: this.dinger,
      props: {
        angle: { value: -90, duration: 150,delay:150, ease: 'Back.easeIn' },
        y: {
          value: this.dingY + this.endOffset,
          duration: 150,
          ease: 'Quad.easeOut',
        }
      },

      onComplete: () => {
        scene.sound.play('ting');
        if (callback !== undefined) {
          callback();
        }
        this.pressTween = scene.tweens.add({
          targets: this.dinger,
          props: {
            angle: {
              value: 0,
              duration: 150,
              ease: 'Quad.easeInOut'
            },
            y: {
              value: this.dingY,
              duration: 150,
              ease: 'Quad.easeInOut'
            }
          },
          onComplete: () => {
            this.animating = false;
          }
        });
      }
    });
  }
}
